import {createEventBus} from '@malt/vue-event-bus/create-event-bus';
import type {FreelancerProfile} from '~/features/keyword-search/pool-of-freelances/types';
import type {AdminDetails} from '~/types/types';

export type Events = {
    'profile-card:admin:click': AdminDetails;
    'profile-card:favorite:add-profile:open-dialog': FreelancerProfile;
    'profile-card:favorite:add-profile:close-dialog': void;
    'profile-card:favorite:create-list:open-dialog': FreelancerProfile;
    'ai-brief-entrypoint:briefId-ready': string;
    'ai-brief-entrypoint:prompt-submitted': {redirectUri: string};
    'ai-brief-entrypoint:keyword-search': {searchUrl: string};
    'ai-brief-entrypoint:agent-prompt-submitted': {prompt: string};
    'ai-brief-entrypoint:validation-error': string;
    'ai-brief-entrypoint:onboarding-targetted-element-created': {
        boundingRect: {
            width: string;
            height: string;
            top: string;
            left: string;
        };
        type: 'AI_MATCHING_BUTTON' | 'KEYWORD_SEARCH_BUTTON';
    };
};

export const eventBus = createEventBus<Events>();
